/* eslint-disable */
import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  useMemo,
  useCallback,
  createContext,
  Children,
} from 'react';

export const DropdownContext = createContext({});

const DropdownRoot = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef(null);
  const containerRef = useRef(null);

  const toggle = useCallback(() => setIsOpen((prev) => !prev), []);
  const close = useCallback(() => setIsOpen(false), []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        triggerRef.current?.contains(event.target) ||
        containerRef.current?.contains(event.target)
      ) {
        return;
      }
      close();
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [close]);

  const contextValue = useMemo(
    () => ({
      isOpen,
      toggle,
      close,
      triggerRef,
      containerRef,
    }),
    [isOpen, toggle, close],
  );

  return (
    <DropdownContext.Provider value={contextValue}>
      <div style={{ position: 'relative' }}>{children}</div>
    </DropdownContext.Provider>
  );
};


export default DropdownRoot;
